<template>
  <div>
    <b-form-group v-bind:label="Datafield.label" v-bind:description="Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-hashtag"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-input type="number" required v-bind:name="Datafield.name"  v-bind:placeholder="Datafield.label" v-model="measurementValueDisplay"></b-form-input>
    </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'inputNumber',
  props: {
    field: { required: true },
    data: { required: true }
  },
  data: function () {
    return {
      Datafield: {},
      Datadata: '',
      enteredValue: ''
    }
  },
  watch: {
    data: function (newValue) {
      this.measurementValueDisplay = newValue
    }
  },
  mounted () {
    this.Datafield = this.field
    this.Datadata = this.data
    this.enteredValue = this.data
  },
  computed: {
    measurementValueDisplay: {
      get: function () {
        return this.enteredValue
      },
      set: function (newValue) {
        this.enteredValue = newValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputNumber.vue